import { useIsAdhaJourney } from '@/core/hooks';
import { PaymentsScreen } from '@/modules/payments';
import { PaymentsScreenWeb } from '@/modules/payments/PaymentsScreenWeb';
import { Redirect } from 'expo-router';
import React from 'react';
import { Platform } from 'react-native';

/** Payments tab — blocked for ADHA journey. */
export default function PaymentsTab() {
  const isAdhaJourney = useIsAdhaJourney();

  if (Platform.OS === 'web' && isAdhaJourney) {
    return <Redirect href="/(auth)/(home)" />;
  }

  if (Platform.OS === 'web') {
    return <PaymentsScreenWeb />;
  }
  return <PaymentsScreen />;
}
